import { messageType, pushSystemMessage } from "../../common/actions/systemMessage.js";

import Logger from "../../common/util/Logger.js";
import {botstrapDeliveryAndOrder} from "./delivery.js";

/**
 * Collects all info regarding active order
 * @param {string} newView 
 * @returns {func}
 */
export function initiateCurrentOrder(){
    return async (dispatch) => {
        try {
            //get the upcoming deliveries
            dispatch( botstrapDeliveryAndOrder() );
            
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Preparing order failed", messageType.error));
            Logger.error(error);
        }
    };
}